import React from "react";
import { renameExtension } from "../_global";

export class EmojiIcon extends React.Component {
    constructor(props) {
        super(props);

        this.add = this.add.bind(this);
        this.tipSet = this.tipSet.bind(this);
        this.tipClear = this.tipClear.bind(this);
    }

    add() {
        this.props.add(this.props.section, this.props.icon);
    }

    tipSet() {
        this.props.tip(this.props.icon + renameExtension(this.props.section));
    }

    tipClear() {
        this.props.tip("");
    }

    render() {
        return (
            <div 
                className="emoji-icon" 
                onClick={this.add}
                onMouseOver={this.tipSet}
                onMouseOut={this.tipClear}
            >
                <img 
                    src={"./img/" + this.props.collection + "/" + this.props.section + "/" + this.props.icon + ".png"} 
                    alt={this.props.icon}
                    draggable="false"
                />
            </div>
        );
    }
}
